import { render, staticRenderFns } from "./reports.vue?vue&type=template&id=37821330&scoped=true&"
import script from "./reports.vue?vue&type=script&lang=js&"
export * from "./reports.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/reportEditor/reportEditor.less?vue&type=style&index=0&id=37821330&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37821330",
  null
  
)

component.options.__file = "reports.vue"
export default component.exports